import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
import { computed, defineComponent, onMounted, ref, watch } from "@vue/composition-api";
import ReportTabLayout from "../report-tab-layout.vue";
import ReportToolbar from "../report-toolbar.vue";
import MaterialInput from "@Shared/components/inputs/material-input.vue";
import DateSection from "@Shared/components/sections/date-section.vue";
import Field from "@Shared/components/sections/field.vue";
import SelectLevel from "../select-level.vue";
import SelectFormat from "../select-format.vue";
import { useI18n } from "vue-i18n-composable";
import AgentsSelect from "@Broker/@Modules/agents/components/agents-select.vue";
import SelectApplicationStatus from "../select-application-status.vue";
import * as ReportsGetters from "../../store/reports-getters";
import * as AccountGetters from "@Broker/@Modules/main/store/account/account-getters";
import { useReportsStoreGetters } from "../../store/reports-helpers";
import { useAccountStoreGetters } from "@Broker/@Modules/main/store/account/account-helpers";
import { REPORT_APPLICATION_STATUS_E, REPORT_DATE_TYPE_E, REPORT_LEVEL_E } from "@Broker/@Types/reports/types";
import { capitalize, cloneDeep } from "lodash";
import FirmStatisticsLoader from "./firm-statistics-container-loader.vue";
import { validationMixin } from "vuelidate";
import { required, requiredIf } from "vuelidate/lib/validators";
import { useVuelidate } from "@Shared/@Composables/validations/useVuelidate";
import { useMultipleSelect } from "@Shared/@Composables/generic/useMultipleSelect";
import { useAIRDateRange } from "@Broker/@Composables/reports/useAIRDateRange";
import { useReportDefaultSettings } from "@Broker/@Composables/reports/useReportDefaultSettings";
import vSelectField from "@Shared/components/form-elements/fields/v-select-field.vue";
export default defineComponent({
  name: "FirmStatisticsContainer",
  components: {
    ReportTabLayout,
    ReportToolbar,
    MaterialInput,
    DateSection,
    Field,
    SelectLevel,
    AgentsSelect,
    SelectApplicationStatus,
    SelectFormat,
    FirmStatisticsLoader,
    vSelectField
  },
  mixins: [validationMixin],
  props: {
    runningReport: {
      type: Object,
      default: () => ({
        loading: false,
        loadingSucceeded: true
      })
    }
  },
  validations() {
    return {
      firmStatisticsValues: {
        dateType: {
          required
        },
        dateFrom: {
          required
        },
        dateTo: {
          required
        },
        selectedLevel: {
          required
        },
        selectedAgents: {
          required: requiredIf(() => this.showAgentsSelect)
        },
        selectedApplicationStatus: {
          required
        },
        selectedFormat: {
          required
        }
      }
    };
  },
  setup(props, {
    emit
  }) {
    const loading = ref(false);
    const {
      v$
    } = useVuelidate();
    const {
      t,
      tc
    } = useI18n();
    const {
      handleSelectMultipleChange
    } = useMultipleSelect();
    const unsyncedAppsModal = ref();
    const dateTypeOptions = computed(() => {
      return [{
        text: t("application-reports.firm-statistics.submissionDate"),
        id: REPORT_DATE_TYPE_E.SUBMISSION_DATE
      }, {
        text: t("application-reports.firm-statistics.approvalDate"),
        id: REPORT_DATE_TYPE_E.APPROVAL_DATE
      }, {
        text: t("application-reports.firm-statistics.closingDate"),
        id: REPORT_DATE_TYPE_E.CLOSING_DATE
      }];
    });
    const setDefaultButtonProps = ref({
      loading: false,
      loadingSucceeded: true
    });
    const allAgentsOption = {
      id: "all",
      username: "all",
      givenName: capitalize(tc("global.words.all", 1)),
      familyName: ""
    };
    const options = computed(() => ({
      placeholder: t("global.actions.chooseOption")
    }));
    const {
      CURRENT_ACCOUNT_IS_BROKER,
      CURRENT_USER_USERNAME
    } = useAccountStoreGetters([AccountGetters.CURRENT_ACCOUNT_IS_BROKER, AccountGetters.CURRENT_USER_USERNAME]);
    const {
      GET_FIRM_STATISTICS_STRUCTURE
    } = useReportsStoreGetters([ReportsGetters.GET_FIRM_STATISTICS_STRUCTURE]);
    const firmStatisticsStructure = cloneDeep(GET_FIRM_STATISTICS_STRUCTURE.value);
    const firmStatisticsValues = ref(firmStatisticsStructure);
    const showAgentsSelect = computed(() => {
      var _firmStatisticsValues;
      return CURRENT_ACCOUNT_IS_BROKER.value && ((_firmStatisticsValues = firmStatisticsValues.value) == null ? void 0 : _firmStatisticsValues.selectedLevel) === REPORT_LEVEL_E.AGENT;
    });
    const dateRange = computed(() => {
      var _firmStatisticsValues2, _firmStatisticsValues3, _firmStatisticsValues4, _firmStatisticsValues5;
      return {
        start: (_firmStatisticsValues2 = (_firmStatisticsValues3 = firmStatisticsValues.value) == null ? void 0 : _firmStatisticsValues3.dateFrom) != null ? _firmStatisticsValues2 : "",
        end: (_firmStatisticsValues4 = (_firmStatisticsValues5 = firmStatisticsValues.value) == null ? void 0 : _firmStatisticsValues5.dateTo) != null ? _firmStatisticsValues4 : ""
      };
    });
    onMounted(() => {
      setDefaultAgentIfNeeded();
    });
    const setDefaultAgentIfNeeded = () => {
      if (!CURRENT_ACCOUNT_IS_BROKER.value) firmStatisticsValues.value.selectedAgents = [CURRENT_USER_USERNAME.value];
    };
    const handleChangeDates = range => {
      if (!firmStatisticsValues.value) return;
      firmStatisticsValues.value.dateFrom = range.start;
      firmStatisticsValues.value.dateTo = range.end;
    };
    const handleSelectAgentChange = (value, type) => {
      firmStatisticsValues.value.selectedAgents = handleSelectMultipleChange(value, type, firmStatisticsValues.value.selectedAgents, true);
    };
    const {
      loadReportDefaultValues,
      updateReportDefaults
    } = useReportDefaultSettings({
      reportType: "firmStatistics",
      reportDataRef: firmStatisticsValues
    });
    const resetToDefaultValues = () => {
      loadReportDefaultValues();
      setDefaultAgentIfNeeded();
    };
    const setDefaultValues = async () => {
      setDefaultButtonProps.value.loading = true;
      const {
        selectedAgents: agents,
        selectedFormat: format,
        selectedLevel: level,
        dateFrom,
        dateTo,
        dateType,
        selectedApplicationStatus: applicationStatus,
        filterForAIR: annualInformationReturn
      } = firmStatisticsValues.value;
      await updateReportDefaults({
        agents,
        level,
        dateFrom,
        dateTo,
        applicationStatus,
        dateType,
        annualInformationReturn,
        format
      });
      setDefaultButtonProps.value.loading = false;
    };
    const handleRunReport = async () => {
      emit("run-report", {
        reportType: "firm-statistics",
        data: firmStatisticsValues.value
      });
    };
    const handleClearSelection = () => {
      firmStatisticsValues.value = cloneDeep(firmStatisticsStructure);
      setDefaultAgentIfNeeded();
    };
    const {
      airDateRange
    } = useAIRDateRange();
    const handleChangeAIR = () => {
      if (!firmStatisticsValues.value || !firmStatisticsValues.value.filterForAIR) return;
      firmStatisticsValues.value = _objectSpread(_objectSpread({}, firmStatisticsValues.value), {}, {
        selectedLevel: CURRENT_ACCOUNT_IS_BROKER.value ? REPORT_LEVEL_E.BROKERAGE : REPORT_LEVEL_E.AGENT,
        dateType: REPORT_DATE_TYPE_E.SUBMISSION_DATE,
        dateFrom: airDateRange.value.dateFrom,
        dateTo: airDateRange.value.dateTo,
        selectedApplicationStatus: [REPORT_APPLICATION_STATUS_E.PAID, REPORT_APPLICATION_STATUS_E.CLOSED]
      });
    };
    watch(() => firmStatisticsValues.value.selectedLevel, (selectedLevel, oldSelectedLevel) => {
      if (selectedLevel === oldSelectedLevel) return;
      if (selectedLevel === REPORT_LEVEL_E.BROKERAGE) {
        firmStatisticsValues.value.selectedAgents = "all";
      }
    });
    return {
      dateTypeOptions,
      options,
      firmStatisticsValues,
      loading,
      dateRange,
      setDefaultButtonProps,
      handleRunReport,
      resetToDefaultValues,
      handleChangeDates,
      handleChangeAIR,
      setDefaultValues,
      handleClearSelection,
      v$,
      showAgentsSelect,
      allAgentsOption,
      CURRENT_ACCOUNT_IS_BROKER,
      handleSelectAgentChange,
      setDefaultAgentIfNeeded,
      unsyncedAppsModal
    };
  }
});